module.exports = __webpack_public_path__ + "static/media/login-white.b4930b48.svg";